import { Pill } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const RCFStatusPill = () => {
    return (
        <Pill variant="green" size="small">
            <FormattedMessage
                id="_.dashboard.rcf_title_active"
                defaultMessage="active"
            />
        </Pill>
    );
};
